var map = {
	"./default_bg_3.png": 703,
	"./default_bg_3_2.png": 704,
	"./default_bg_3_3.png": 705,
	"./default_bg_3_4.png": 706,
	"./default_bg_3_5.png": 707,
	"./default_bg_3_6.png": 708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1863;